(function () {
  function wrapProductSections() {
    const main = document.getElementById('MainContent');
    if (!main) return;

    const startSection = main.querySelector('[id$="__main-product"]');
    if (!startSection) return;

    if (main.querySelector('.product-below-wrapper')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'product-below-wrapper';

    let node = startSection.nextElementSibling;
    startSection.after(wrapper);
    while (node) {
      const next = node.nextElementSibling;
      wrapper.appendChild(node);
      node = next;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapProductSections);
  } else {
    wrapProductSections();
  }

  document.addEventListener('shopify:section:load', wrapProductSections);
  document.addEventListener('shopify:section:unload', wrapProductSections);
})();
